module.exports = __webpack_public_path__ + "static/img/gpt21.18c2f3e3.png";